// Prize editor modes
export const CATEGORY_PRIZES_MODE = 'category';
export const RANKED_PRIZES_MODE = 'default';

// Category Types
export const CATEGORY_RANKED = 'category_ranked';
export const CATEGORY_CUSTOM = 'category_custom';
export const RANKED_DEFAULT = 'ranked';
export const RUNNER_UPS = 'runner_ups';
